import React from "react";
import { Button, message, Input } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { useKeyWordsModel } from "../keyWordsModel";
import { DataTable1 } from "./DataTable1";

export const DataBox = () => {
	const { setKeyWordsTypeDrawer, setKeyWordsDrawer, loadData, loadDataType, searchParam, setSearchParam } = useKeyWordsModel(({ searchParam }) => [searchParam]);

	const rightChildrenType = <>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => setKeyWordsTypeDrawer({ visible: true, mode: "add" })}
		>新增</Button>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => loadDataType({ pageNum: 1 }, {}).then(res => { res && message.success("已刷新") })}
		>刷新</Button>
	</>;
	const rightChildren = <div className="flex">
		<Input
			allowClear
			datatype="round"
			className="border-r-16 mr-10"
			placeholder="关键词名称"
			value={searchParam?.name}
			onChange={(e) => setSearchParam({ name: e.target.value })}
			onPressEnter={() => loadData({ pageNum: 1 })}
		/>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => setKeyWordsDrawer({ visible: true, mode: "add" })}
		>新增</Button>
		<Button
			className="mr-5"
			type="link"
			shape="round"
			onClick={() => loadData({ pageNum: 1 }, {}).then(res => { res && message.success("已刷新") })}
		>刷新</Button>
	</div>;

	return (
		<>
			<YhBox title="关键词分类管理" rightChildren={rightChildrenType}>
				<DataTable />
			</YhBox>
			<YhBox title="关键词管理" rightChildren={rightChildren} style={{ marginTop: "15px" }}>
				<DataTable1 />
			</YhBox>
		</>
	)
}